<template>
  <div>
    <div v-if="usedTags.length">
      <span>
        <tag-chip v-for="tag in usedTags"
                  :tag="tag"
                  :key="tag.name"
                  no-click
                  class="list-tag"
        />
      </span>
      <span>
        <tag-chip :tag="{name: 'edit tags', pseudo: true}"
                  @click="showTagsModal"
                  class="list-tag"
        />
      </span>
    </div>
    <div v-else>
      <f7-input type="text"
                @focus="showTagsModal"
                placeholder="Select tags"
      />
    </div>
    <f7-popup :opened="poppedUp"
              @popup:closed="popupClosed"
              @popup:opened="popupOpened"
              :close-by-backdrop-click="false"
    >
      <tag-entry-inner @input="taginput"
                       :value="usedTags"
                       ref="input"
                       @confirm="popupConfirm"
                       @cancel="popupCancel"
      />
    </f7-popup>
  </div>
</template>

<script>
  import TagChip from './TagChip'
  import TagEntryInner from '@/components/TagEntryInner'


  export default {
    directives: {},
    name: 'TagEntry',
    components: {TagEntryInner, TagChip},
    props: {
      value: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        usedTags: this.value,
        oldTags: [],
        poppedUp: false,
        text: '',
      }
    },
    watch: {
      usedTags () {
        this.$emit('input', this.usedTags)
      },
      value () {
        this.usedTags = this.value
      },
    },
    computed: {},
    async mounted () {
      await this.$store.dispatch('tags/fetch')
    },
    beforeDestroy () {
    },
    methods: {
      showTagsModal () {
        this.poppedUp = true
      },
      popupOpened () {
        this.oldTags = [...this.usedTags]
        this.$refs.input.$el.querySelector('input').focus()
      },
      popupClosed () {
        this.poppedUp = false
      },
      popupConfirm () {
        this.poppedUp = false
        this.$emit('set-tags', this.usedTags)
      },
      popupCancel () {
        this.poppedUp = false
        this.usedTags = [...this.oldTags]
      },
      taginput (tags) {
        this.usedTags = tags
      },
    },
  }
</script>

<style lang="scss" scoped>
  .list-tag {
    margin-right: 0.1em;
  }
</style>

<style lang="scss">
</style>
